<template>
  <div v-if="editor">
    <v-row
      no-gutters
      style="position: relative"
      @click="openFieldOptions"
      v-click-outside="closeFieldOptions"
    >
      <v-col
        cols="12"
        class="tiptapClass d-flex"
        :class="{ 'mt-1': isMobileBreakpoint }"
      >
        <editor-content style="width: 92.5%" :editor="editor" />
        <v-btn
          v-if="editor.getHTML() !== '<p></p>'"
          style="width: 24px; height: 24px; margin-top: 2px"
          icon
          @click="clearAllInput"
          ><v-icon size="16">mdi-close</v-icon></v-btn
        >
      </v-col>
      <v-card
        v-if="fieldOptions"
        class="mt-14 floating-card"
        style="user-select: none"
        elevation="4"
        width="700px"
      >
        <v-row no-gutters>
          <v-col cols="12" class="pl-3 py-2">
            <v-row no-gutters class="d-flex">
              <div
                class="mr-2 mb-1 mt-1 d-flex"
                v-for="(webhookField, i) in fieldTitles"
                :key="i"
              >
                <v-tag type="neutral" @click="addTiptapMention(webhookField)">
                  <v-icon>mdi-plus</v-icon>{{ webhookField }}
                </v-tag>
              </div>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
    </v-row>
  </div>
</template>

<script>
import Mention from '@tiptap/extension-mention'
import { mapState } from 'vuex'
import { Editor, EditorContent } from '@tiptap/vue-2'
import Document from '@tiptap/extension-document'
import Paragraph from '@tiptap/extension-paragraph'
import Text from '@tiptap/extension-text'

export default {
  components: {
    EditorContent,
  },
  props: {
    name: String,
    webhookFields: Array,
    contentValue: Array,
  },
  data() {
    return {
      editor: null,
      fieldOptions: false,
      webhookOptions: [],
    }
  },
  computed: {
    ...mapState({
      isMobileBreakpoint: (state) => state.user.isMobileBreakpoint,
    }),
    fieldTitles() {
      return this.webhookFields.map((field) => field.title)
    },
  },
  watch: {
    contentValue: {
      immediate: true,
      deep: true,
      handler(val) {
        if (this.editor) {
          if (val.length) {
            this.setInputContent(val)
          } else {
            this.editor.commands.clearContent()
          }
        }
      },
    },
  },
  created() {},
  mounted() {
    this.editor = new Editor({
      extensions: [
        Document,
        Paragraph,
        Text,
        Mention.configure({
          HTMLAttributes: {
            class: 'mention',
          },
        }),
      ],
      content: '',
    })
    this.editor.on('update', () => {
      this.$emit('updateContent', this.editor.getJSON())
    })
    this.$root.$on(`getValue-${this.name}`, () => {
      this.$root.$emit('updateFieldValue', this.name, this.editor.getJSON())
    })
    this.setInputContent(this.contentValue)
  },
  beforeDestroy() {
    this.$root.$off(`getValue-${this.name}`)
    this.$root.$off(`setContent-${this.name}`)
  },
  methods: {
    clearAllInput() {
      this.setInputContent('')
      this.$emit('updateContent', this.editor.getJSON())
    },
    setInputContent(content) {
      this.editor.commands.setContent({
        type: 'doc',
        content: [
          {
            type: 'paragraph',
            content: content,
          },
        ],
      })
    },
    addTiptapMention(val) {
      this.editor.commands.insertContent({
        type: 'mention',
        attrs: {
          id: `${val}`,
          label: null,
        },
      })
    },
    openFieldOptions() {
      this.fieldOptions = true
    },
    closeFieldOptions() {
      if (this.fieldOptions) {
        setTimeout(() => {
          this.fieldOptions = false
        }, 50)
      }
    },
  },

  beforeUnmount() {
    this.editor.destroy()
  },
}
</script>

<style lang="scss">
.tiptapClass {
  padding: 5px 5px 5px 5px !important;
  border: 1px solid varFigma(neutral-95-lightest);
  border-radius: 4px;
  min-height: 39px;
  margin-top: 16px;
}
.tiptapClass div {
  height: 100%;
}
.tiptapClass div div {
  height: 100%;
}
.tiptapClass div div p {
  height: 100%;
}
.tiptapClass .mention {
  font-family: Rubik;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
  background: varFigma(neutral-95-lightest);
  border-radius: 16px;
  border: 1px solid varFigma(neutral-95-lightest);
}
.tiptapClass p {
  font-family: Rubik;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  margin-bottom: 0px !important;
}
.floating-card {
  position: absolute !important;
  z-index: 999 !important;
}
.ProseMirror {
  top: 2px;
}
.ProseMirror {
  > * + * {
    margin-top: 0.75em;
  }
}

.ProseMirror:focus {
  outline: none;
}

#someselector {
  all: initial;
  * {
    all: unset;
  }
}

.mention {
  border: 1px solid #000;
  border-radius: 0.4rem;
  padding: 0.1rem 0.3rem;
  box-decoration-break: clone;
}
</style>
